import { Action } from "../../types";

export const SET_CURRENT_MODAL_ASSETS = "SET_CURRENT_MODAL_ASSETS";

export const setCurrentModalAssets = (assetIds: number[]): Action => ({
    type: SET_CURRENT_MODAL_ASSETS,
    payload: { assetIds }
});
